import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-feeds-creative-card',
  templateUrl: './feeds-creative-card.component.html',
  styleUrls: ['./feeds-creative-card.component.scss']
})
export class FeedsCreativeCardComponent implements OnInit {
  @Input() creative: any;
  isWideImage: boolean = false;
  constructor() { }

  ngOnInit(): void {
    const img = new Image();
    img.src = this.creative.media[0].url;
    img.onload = () => {
      this.isWideImage = img.width > img.height;
    };
  }

}
